"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eth_estimateGas = void 0;
const index_js_1 = require("../utils/index.js");
// 1 Energy = 100 SUN
function eth_estimateGas(params, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        // TODO
        // java-tron does not support equivalent API call so we just return the max energy limit...
        // 1 energy = 100 SUN
        return index_js_1.numberToHex(1e9);
    });
}
exports.eth_estimateGas = eth_estimateGas;
